(function () {
    'use strict';
 
    angular
        .module('app')
        .filter('slugify', Filter);
 
    function Filter() {
        return function (input) {
            if (!input)
                return;
 
            // make lower case and trim
            var slug = input.toLowerCase().trim();
            slug = slug.replace(/á/gi,"a");
            slug = slug.replace(/é/gi,"e");
            slug = slug.replace(/í/gi,"i");
            slug = slug.replace(/ó/gi,"o");
            slug = slug.replace(/ú/gi,"u");
            slug = slug.replace(/ñ/gi,"n");
            slug = slug.replace(/à/gi,"a");
            slug = slug.replace(/è/gi,"e");
            slug = slug.replace(/ì/gi,"i");
            slug = slug.replace(/ò/gi,"o");
            slug = slug.replace(/ù/gi,"u");
            slug = slug.replace(/ç/gi,"c");
            
            // replace invalid chars with spaces
            slug = slug.replace(/[^a-z0-9\s-]/g, '');
 
            // replace multiple spaces or hyphens with a single hyphen
            slug = slug.replace(/[\s-]+/g, '-');
 
            return slug;
        };
    }
})();